import { Routes } from '@angular/router';
export const Full_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../modules/modules.module').then(m => m.ModulesModule)
  },
  { path: 'access-management', loadChildren: () => import('../../modules/access-management/access-management.module').then(m => m.AccessManagementModule) }
];
